import React from 'react'
import webhook from '../../img/6538623-removebg-preview.png'


const WebhookHeader = () => {
  return (
    <div className='account__profile flex'>
        <div className="account__profile__">
            <h5 className="inner__page__title">
                Your Webhook
            </h5>
            <p>
                We have given you the power to integrate your application
                with our sytem. Use your webhook url to recieve status of your messages.
            </p>
        </div>
        <img className='api__webhook__img' src={webhook} alt="" />
    </div>
  )
}

export default WebhookHeader